import { render, staticRenderFns } from "./eProclamas.vue?vue&type=template&id=1f589659&"
import script from "./eProclamas.vue?vue&type=script&lang=js&"
export * from "./eProclamas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports